export default {
  namespaced: true,
  assigned_video_tours: {
    title: "Asignación de video tours",
    single: "Asignación de video tour",
    all: "todos los recorridos en video asignados",

    current_assignment: "asignación actual",
    schedule_video_tours: "programar recorridos en video",
    change: "cambiar",
    change_now: "cambiar ahora",

    video_tour: "recorrido en video",
    video_tours: "recorridos en video",
    sector: "sector",
    sectors: "sectores",

    analyst: "analista",
    supervisor: "supervisor",
    change_supervisor: "cambiar supervisor",
    change_video_tours: "cambiar recorridos en video",

    scheduled: "programado",
    programmed: "programado",
    manual_change: "cambio manual",

    init_date: "fecha de inicio",
    end_date: "fecha de finalización",
    active_at: "activo en",
    active_at_help: "Filtrar asignaciones activas en una fecha y hora específicas.",
    since: "desde",

    select_supervisor: "selecciona un supervisor",
    select_sector: "selecciona un recorrido en video",
    select_sectors: "selecciona recorridos en video",
    select_analyst: "selecciona un analista",

    supervisor_optional: "El supervisor es opcional.",
    no_supervisor: "sin supervisor asignado",
    no_video_tours: "sin recorridos en video asignados",

    effective_assignment: "asignación efectiva",
    assignment_history: "historial de asignaciones",
    programmed_assignment: "asignación programada",
    current_supervisor: "supervisor actual",
    current_video_tours: "recorridos en video actuales",

    save_programmed: "guardar asignación programada",
    save_change: "guardar cambio",

    messages: {
      created: "Asignación creada correctamente.",
      updated: "Asignación actualizada correctamente.",
      deleted: "Asignación eliminada correctamente.",
      changed: "Asignación cambiada correctamente.",
      closed: "La anulación actual se cerró correctamente.",
      load_error: "Error al cargar las asignaciones.",
      save_error: "Error al guardar la asignación.",
      delete_error: "Error al eliminar la asignación.",
      change_error: "Error al cambiar la asignación.",
      required_supervisor: "Por favor selecciona un supervisor.",
      required_video_tours: "Por favor selecciona al menos un recorrido en video.",
    },
  },
};